import { useMutation, useQueryClient } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addReview = (postData) => {
  return http().post(endpoints.reviews.postReview, postData);
};

export function usePostReviews() {
  const queryClient = useQueryClient();
  return useMutation(addReview, {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchReviews"]);
    },
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
